import FormidableForm from '@/utils/formidable-form'

export function useFormidableForm(formId, defaultValues) {
  const { $config, $restClient } = useNuxtApp()

  return FormidableForm.create(formId, $config, $restClient, defaultValues)
}
